import {Injectable} from '@angular/core';
import {StorageService} from '../storage/storage.service';
import {ViewContent} from '../../model/typings/view.types';
import {NavItem} from '../../model/typings/nav.types';
import {ContentDetailMessage} from '../../model/typings/content.types';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class ContentStateService {
  contentForViewMax = 10;
  contentForViewMap = new Map<string, ViewContent>();
  activeContentForView: ViewContent;
  activeContentForViewObservable: BehaviorSubject<ViewContent> = new BehaviorSubject<ViewContent>(this.activeContentForView);
  activeSubNavList: NavItem[];
  activeSubNavListObservable: BehaviorSubject<NavItem[]> = new BehaviorSubject<NavItem[]>(this.activeSubNavList);

  activeMessageContentDetail: ContentDetailMessage;
  activeMessageContentDetailObservable: BehaviorSubject<ContentDetailMessage> =
    new BehaviorSubject<ContentDetailMessage>(this.activeMessageContentDetail);

  constructor(private storageService: StorageService) {
    this.resetContentStateService();
  }

  private trimContentForViewMap() {
    const contentKeys = this.contentForViewMap.keys();
    const firstKeyInContentViewCache = Array.from(contentKeys)[0];
    console.log(`CPUI - ContentStateService.trimContentForViewMap()`, firstKeyInContentViewCache);

    this.deleteViewContentCache(firstKeyInContentViewCache);
  }

  private resetContentForView() {
    console.log(`CPUI - ContentStateService.resetContentForView()`);
    this.contentForViewMap.clear();
  }

  private resetContentStateService() {
    console.log(`CPUI - ContentStateService.resetContentStateService()`);
    this.resetContentForView();
  }

  updateContentForView(viewId: string, contentForView: ViewContent) {
    console.log(`CPUI - ContentStateService.updateContentForView()`, contentForView, this.contentForViewMap.size);

    if (this.contentForViewMap.size > this.contentForViewMax) {
      this.trimContentForViewMap();
    }

    this.setActiveSubNavList(contentForView.navItems);

    this.contentForViewMap.set(viewId, contentForView);

    return this.contentForViewMap.get(viewId);
  }

  hasViewContentCache(id: string) {
    console.log(`CPUI - ContentStateService.hasViewContentCache()`, id, this.contentForViewMap.has(id));
    return this.contentForViewMap.has(id);
  }

  deleteViewContentCache(id: string): void {
    console.log(`CPUI - ContentStateService.deleteViewContentCache()`, id);
    this.contentForViewMap.delete(id);
  }

  getViewContentCache(id: string): Observable<ViewContent> {
    console.log(`CPUI - ContentStateService.getViewContentCache()`, id);
    this.activeContentForView = this.contentForViewMap.get(id);

    this.activeContentForViewObservable.next(this.activeContentForView);

    this.setActiveSubNavList(this.activeContentForView.navItems);

    return this.activeContentForViewObservable.asObservable();
  }

  setActiveMessageContentDetail(messageContentDetail: ContentDetailMessage) {
    console.log(`CPUI - ContentStateService.setMessageContentDetail()`, messageContentDetail);
    this.activeMessageContentDetail = messageContentDetail;
    this.activeMessageContentDetailObservable.next(this.activeMessageContentDetail);
  }

  setActiveSubNavList(navItems: NavItem[]) {
    console.log(`CPUI - ContentStateService.setActiveSubNavList()`, navItems);

    // NOTE: setTimeout needed to avoid routing complexity issues
    setTimeout(() => {
      this.activeSubNavList = [...navItems];
      this.activeSubNavListObservable.next(this.activeSubNavList);
    }, 100);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/content/content-state.service.ts